import { get } from 'lodash';
import { Icon, IconButton } from '@ts/storybook';

import { TableContainer, Table, TableBody, TableCell, TableHead, TableRow, Paper } from '@mui/material';
import { useTranslation } from 'react-i18next';

interface IconRulesProps {
  rows: any[];
  disabled?: boolean;
  onDelete: (idx: number) => void;
}

const IconRules = ({ rows = [], disabled, onDelete }: IconRulesProps) => {
  const { t } = useTranslation();
  return (
    <TableContainer component={Paper}>
      <Table size="small">
        <TableHead>
          <TableRow>
            <TableCell>{t('Operation')}</TableCell>
            <TableCell>{t('Operand')}</TableCell>
            <TableCell>{t('Icon')}</TableCell>
            <TableCell>{t('Actions')}</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {rows.map((row, idx) => (
            <TableRow key={idx}>
              <TableCell>{get(row, 'rule.operation', '?')}</TableCell>
              <TableCell>{get(row, 'rule.operand', '?').toString()}</TableCell>
              <TableCell>
                <Icon icon={row.icon} />
              </TableCell>
              <TableCell>
                <IconButton
                  onClick={() => {
                    onDelete(idx);
                  }}
                  disabled={disabled}
                >
                  <Icon icon="action-delete" />
                </IconButton>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default IconRules;
